var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProgressBarFinishPoleLeftinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 2.524,
  height: 26.745
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 784"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1235",
  d: "M.762 26.521c-.282 0-.51-.155-.51-.346V.598c0-.191.228-.346.51-.346s.51.155.51.346v25.577c0 .191-.228.346-.51.346",
  fill: "#eba47f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1236",
  d: "M.762 26.745c-.42 0-.762-.233-.762-.519V.519C0 .233.342 0 .762 0s.762.233.762.519v25.706c0 .286-.342.519-.762.519m0-26.4C.62.344.504.423.504.52v25.705c0 .1.116.176.258.176s.258-.079.258-.176V.519c0-.1-.116-.176-.258-.176",
  fill: "#333548"
}))));
export default SvgProgressBarFinishPoleLeftinline;